import { request, Row } from './request';
import AppError from './models/common/res/AppError';
import { ShortUrl } from './models/short-url/res/ShortUrl';

/**
 * 시술 유의 사항 목록 조회
 */
export const fetchShortUrl = async (code: string) => {
  try {
    const { data } = await request<Row<ShortUrl>>({
      method: 'get',
      url: `/common/short-url/${code}`,
    });
    return data.row;
  } catch (e) {
    throw new AppError(e);
  }
};
